(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var $9qXVL = parcelRequire("9qXVL");
var $48ea0 = parcelRequire("48ea0");

var $3dxyq = parcelRequire("3dxyq");

var $jhF7K = parcelRequire("jhF7K");

var $5Uayz = parcelRequire("5Uayz");

var $73eF4 = parcelRequire("73eF4");

var $hfp43 = parcelRequire("hfp43");
const $a5c8363800b1e9f9$export$d641c58d62c1c984 = (paymentCode)=>{
    return (0, $hfp43.default).get(`${"https://myheronapim.azure-api.net/guest/checkPaymentCode"}?PaymentCode=${paymentCode}`, {
        headers: {
            "Ocp-Apim-Subscription-Key": "7b89cc0699d94c299fa1631a1b0c2e39"
        }
    });
};



var $7Mtml = parcelRequire("7Mtml");

var $1GLa3 = parcelRequire("1GLa3");

var $jqYVe = parcelRequire("jqYVe");

var $itg3T = parcelRequire("itg3T");

var $7xZPM = parcelRequire("7xZPM");
$48ea0.init({
    dsn: "https://388eda95ee7d478a8484b269881c5a5e@o324589.ingest.sentry.io/5853247",
    release: undefined,
    environment: "production",
    ignoreErrors: [
        "Request aborted",
        "Error: Network Error",
        "TypeError: Cancelled",
        "TypeError: Failed to fetch",
        "timeout exceeded"
    ]
});
function $2e47862d26689fe7$var$invokePayment() {
    (0, $73eF4.toggleButtonLoader)(true);
    const inputsArr = [].slice.call((0, $73eF4.getInputFields)());
    (0, $73eF4.removeErrors)(inputsArr);
    const formData = inputsArr.reduce((accumulator, currentValue)=>{
        return {
            ...accumulator,
            [currentValue.id]: currentValue.value
        };
    }, {});
    if ($2e47862d26689fe7$var$isGuest === false && $2e47862d26689fe7$var$commodity && !(0, $itg3T.isNullOrWhitespace)($2e47862d26689fe7$var$meterId)) {
        $2e47862d26689fe7$var$pay(formData);
        return;
    }
    $2e47862d26689fe7$var$meterId = null;
    $2e47862d26689fe7$var$commodity = null;
    (0, $a5c8363800b1e9f9$export$d641c58d62c1c984)(formData.PaymentCode).then((res)=>{
        if (res.data.Result === true) {
            $2e47862d26689fe7$var$commodity = res.data.Commodity;
            $2e47862d26689fe7$var$pay(formData);
            return;
        }
        (0, $73eF4.addErrorToFields)([
            "PaymentCode"
        ]);
    }).catch((error)=>{
        (0, $73eF4.toggleButtonLoader)(false);
        if (error.response?.data?.ResponseCode === 404) {
            (0, $73eF4.addErrorToFields)([
                "PaymentCode"
            ]);
            return;
        }
        (0, $73eF4.showErrorBox)();
    });
}
function $2e47862d26689fe7$var$pay(formData) {
    const errorFields = (0, $5Uayz.validateForm)(formData);
    if (errorFields.length > 0) {
        (0, $73eF4.addErrorToFields)(errorFields);
        (0, $73eF4.toggleButtonLoader)(false);
        return;
    }
    const jsonFormData = JSON.stringify({
        ...formData,
        CardholderName: null,
        token: $2e47862d26689fe7$var$token,
        accountId: $2e47862d26689fe7$var$accountId,
        createdAt: new Date()
    });
    try {
        localStorage.setItem("myheron_payment_form_data;", jsonFormData);
    } catch (error) {
        const errorMessage = error?.message || "";
        /* catching to avoid QuotaExceeded Errors from being logged. 
    /* not setting data to local storage does not break the functionality of the page. user will just have to reenter the data on the form */ if (errorMessage.toLowerCase().indexOf("quota") === -1) $9qXVL.withScope((scope)=>{
            $9qXVL.captureException(error);
        });
    }
    const amount = (0, $5Uayz.getAmount)(formData.Amount);
    const paymentCode = document.querySelector("#PaymentCode").value;
    const trackUnconfirmedPayment = $2e47862d26689fe7$var$isEna === false;
    //{cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}
    const parameters = [
        formData.CardholderName,
        amount,
        paymentCode,
        $2e47862d26689fe7$var$meterId,
        $2e47862d26689fe7$var$commodity,
        trackUnconfirmedPayment,
        $2e47862d26689fe7$var$invoiceNo
    ];
    try {
        if (paymentCode?.length !== 25) $9qXVL.withScope((scope)=>{
            scope.setExtras({
                parameters: parameters,
                parametersDefinition: "{cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}"
            });
            scope.setLevel("info");
            $9qXVL.captureMessage("Payment page - Wrong Payment Code length in parameters");
        });
    } catch (error) {}
    try {
        if (paymentCode?.trim()?.length !== 25) $9qXVL.withScope((scope)=>{
            scope.setExtras({
                parameters: parameters,
                parametersDefinition: "{cardholderName}|{amount}|{paymentCode}|{meterId}|{commodity}|{trackUnconfirmedPayment}|{invoiceNumber}"
            });
            scope.setLevel("info");
            $9qXVL.captureMessage("Payment page - Wrong Payment Code length in parameters (TRIMMED)");
        });
    } catch (error) {}
    const data = {
        CurrencyCode: 978,
        BillAddrCity: formData.BillAddrCity,
        BillAddrCountry: formData.BillAddrCountry,
        BillAddrLine1: formData.BillAddrLine1,
        BillAddrPostCode: formData.BillAddrPostCode,
        BillAddrState: formData.BillAddrState,
        CardholderName: formData.CardholderName,
        Email: formData.Email,
        HomePhone: (0, $5Uayz.getPhone)(formData.HomePhone),
        Amount: amount,
        Parameters: parameters.join("|")
    };
    if (!$2e47862d26689fe7$var$commodity) {
        $9qXVL.withScope((scope)=>{
            scope.setExtras({
                data: JSON.stringify($2e47862d26689fe7$var$_receivedData)
            });
            scope.setLevel("info");
            $9qXVL.captureMessage("Payment invocation with empty commodity prevented");
        });
        (0, $73eF4.showErrorBox)();
        (0, $73eF4.toggleButtonLoader)(false);
        return;
    }
    (0, $7Mtml.getTicket)(data).then((res)=>{
        const response = res.data;
        const merchantRef = response ? response.MerchantReference : null;
        (0, $5Uayz.populatePaymentKeys)(merchantRef, $2e47862d26689fe7$var$commodity);
        const lang = (0, $3dxyq.getLanguage)();
        document.querySelector("input[name=ParamBackLink]").value = `lang=${lang}`;
        document.querySelector("input[name=LanguageCode]").value = lang === "el" ? "el-GR" : "en-US";
        (0, $73eF4.showDelayAndRemoveBankRedirectionDialog)($2e47862d26689fe7$var$submitForm);
        return;
    }).catch((error)=>{
        (0, $73eF4.showErrorBox)();
    }).finally(()=>{
        (0, $73eF4.toggleButtonLoader)(false);
    });
}
function $2e47862d26689fe7$var$submitForm() {
    document.querySelector("#redirection_form").submit();
}
function $2e47862d26689fe7$var$getBillDetails(token, accountId) {
    if (!token || token.length === 0) return;
    const storedData = (0, $7xZPM.isWebStorageSupported)() && localStorage.getItem("myheron_payment_form_data;");
    if (storedData) {
        const _formData = JSON.parse(storedData);
        if (_formData.token && _formData.token === token && (!_formData.accountId || _formData.accountId === accountId) && //use cached data for 15'
        (new Date() - new Date(_formData.createdAt)) / 1000 / 60 <= 15) {
            (0, $73eF4.fillForm)(_formData);
            (0, $73eF4.enableInputs)();
            document.getElementById("terms").checked = false;
            return;
        }
        localStorage.removeItem("myheron_payment_form_data;");
    }
    (0, $73eF4.togglePageLoader)(true);
    // if you want to use the test endpoint use
    // "api/my-bill";
    (0, $1GLa3.getUserDetails)(token, accountId).then((res)=>{
        // Fill the form
        (0, $73eF4.fillForm)(res.data);
    }).catch((error)=>{
        if (error.response?.status === 401) // no need to log 401 unauthorized errors
        return;
    }).then(()=>{
        (0, $73eF4.togglePageLoader)(false);
        (0, $73eF4.enableInputs)();
    });
}
// Wait for client to send paymentCode: ‘’, amount: '', token: '', guest:
let $2e47862d26689fe7$var$isEna = false;
let $2e47862d26689fe7$var$isGuest = true;
let $2e47862d26689fe7$var$token = null;
let $2e47862d26689fe7$var$accountId = null;
let $2e47862d26689fe7$var$meterId = null;
let $2e47862d26689fe7$var$commodity = null;
let $2e47862d26689fe7$var$isSettlement = false;
let $2e47862d26689fe7$var$invoiceNo = null;
let $2e47862d26689fe7$var$_receivedData = null;
window.addEventListener("message", (event)=>{
    if ((0, $itg3T.isAllowedUrl)(event.origin)) {
        $2e47862d26689fe7$var$_receivedData = event.data;
        if (typeof event.data.guest !== "undefined" || typeof event.data.token !== "undefined") {
            $2e47862d26689fe7$var$isGuest = event.data.guest === true;
            $2e47862d26689fe7$var$token = event.data.token;
            $2e47862d26689fe7$var$accountId = event.data.accountId;
            $2e47862d26689fe7$var$isEna = event.data.isEna === true;
            $2e47862d26689fe7$var$isSettlement = event.data.fixedAmount === true;
            if ($2e47862d26689fe7$var$isGuest === true) {
                document.querySelector("#PaymentCode").disabled = false;
                document.querySelector("#Amount").disabled = false;
                (0, $73eF4.enableInputs)();
                (0, $73eF4.togglePageLoader)(false);
                $2e47862d26689fe7$var$meterId = null;
                $2e47862d26689fe7$var$commodity = null;
            } else if ($2e47862d26689fe7$var$token) {
                if (event.data.paymentCode) {
                    try {
                        if (event.data.paymentCode?.length !== 25) $9qXVL.withScope((scope)=>{
                            scope.setExtras({
                                postData: JSON.stringify(event.data)
                            });
                            scope.setLevel("info");
                            $9qXVL.captureMessage("Payment page - Wrong Payment Code received");
                        });
                    } catch (error) {}
                    document.querySelector("#PaymentCode").value = event.data.paymentCode;
                    document.querySelector("#PaymentCode").disabled = true;
                } else document.querySelector("#PaymentCode").disabled = false;
                if (event.data.amount) document.querySelector("#Amount").value = (0, $5Uayz.getAmountWithCurrency)(event.data.amount);
                if ($2e47862d26689fe7$var$isEna) document.querySelector("#ena_info").style.display = "block";
                if (event.data.meterId) $2e47862d26689fe7$var$meterId = event.data.meterId;
                if (event.data.invoiceNo) $2e47862d26689fe7$var$invoiceNo = event.data.invoiceNo;
                document.querySelector("#Amount").disabled = event.data.fixedAmount === true;
                if (event.data.commodity) $2e47862d26689fe7$var$commodity = `${event.data.commodity}` === `${(0, $jqYVe.commodities).gas}` ? (0, $jqYVe.commodities).gas : (0, $jqYVe.commodities).energy;
                else $9qXVL.withScope((scope)=>{
                    scope.setExtras({
                        postData: JSON.stringify($2e47862d26689fe7$var$_receivedData)
                    });
                    scope.setLevel("info");
                    $9qXVL.captureMessage("Payment page - non guest payment with empty commodity");
                });
                $2e47862d26689fe7$var$getBillDetails($2e47862d26689fe7$var$token, $2e47862d26689fe7$var$accountId);
            }
            const lang = (0, $3dxyq.getLanguage)();
            document.querySelector('label[for="Amount"]').innerHTML = $2e47862d26689fe7$var$isEna ? (0, $3dxyq.langs)[lang].participation : (0, $3dxyq.langs)[lang].debtAmount;
        }
    }
}, false);
window.addEventListener("load", function() {
    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = Array.prototype.forEach;
    (0, $3dxyq.setLanguage)();
    (0, $jhF7K.populateStatesSelect)();
    document.querySelectorAll('input[type="text"]').forEach((x)=>{
        (0, $73eF4.handleErrorClassOnChange)(x);
    });
    // Notify the client that the form has loaded
    window.parent.postMessage("Payment gateway initialised.", "*");
    if (window.callbackHandler) window.callbackHandler.completedSuccessfully("Payment gateway initialised.");
    try {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.completedSuccessfully) window.webkit.messageHandlers.completedSuccessfully.postMessage("Payment gateway initialised.");
    } catch (error) {
        $9qXVL.withScope(function(scope) {
            scope.setExtras({
                snippet: "window.webkit"
            });
            $9qXVL.captureException(error);
        });
    }
    document.querySelector(".close-icon").addEventListener("click", (0, $73eF4.removeErrorBox));
    const checkbox = document.querySelector("input[type=checkbox]");
    const submit = document.querySelector("button[type=submit]");
    checkbox.addEventListener("change", function() {
        submit.disabled = !this.checked;
    });
    const form = document.getElementById("form");
    form.addEventListener("submit", function(event) {
        event.preventDefault();
        $2e47862d26689fe7$var$invokePayment();
    });
});

})();
//# sourceMappingURL=index.5ed69571.js.map
